import { Component, signal } from '@angular/core';
import { NewsSlideoutService } from '../news-slideout/news-slideout.service';
import { NewsItemComponent } from '../news-item/news-item.component';
import { NewsCategory } from '../models/news-category.enum';
import { NewsStateService } from '../news-state.service';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-company-news-list',
  templateUrl: './company-news-list.component.html',
  styleUrls: ['./company-news-list.component.sass'],
  imports: [
    NewsItemComponent,
    AsyncPipe,
    TranslatePipe
  ]
})
export class CompanyNewsListComponent {
  selectedCategory: NewsCategory | null = null;

  items$ = this.newsStateService.items$;
  hasNextPage$ = this.newsStateService.hasNextPage$;
  loading$ = this.newsStateService.loading$;
  error$ = this.newsStateService.error$;

  loadingMore = signal<boolean>(false);

  constructor(private newsStateService: NewsStateService,
              private newsSlideoutService: NewsSlideoutService) { }

  openNewsSlideout(newsId: string): void {
    this.newsSlideoutService.openNewsSlideout(newsId);
  }

  onCategorySelected(category: NewsCategory | null): void {
    this.loadingMore.set(false);
    this.selectedCategory = category;
    this.newsStateService.loadNews(category);
  }

  loadMore(): void {
    this.loadingMore.set(true);
    this.newsStateService.loadMore();
  }

}
